import { useMemo } from 'react';
import { usePostgresChangesRealtime } from './usePostgresChangesRealtime';

export type FormsSettingsTable =
  | 'departments'
  | 'salesperson_emails'
  | 'system_config'
  | 'pricing_update_roles'
  | 'certificate_request_roles'
  | 'certificate_files'
  | 'delivery_schedule_routes'
  | 'form_field_options'
  | 'sharepoint_settings'
  | 'form_definitions';

type Options = {
  enabled?: boolean;
  tables: FormsSettingsTable[];
  onChange?: () => void;
};

/**
 * Live-refresh Forms settings panels (workflow, email, dropdowns, roles, etc.).
 * Requires migrations 268–269.
 */
export function useFormsSettingsRealtime(options: Options) {
  const { enabled = true, tables, onChange } = options;
  const listens = useMemo(
    () =>
      tables.map((table) => ({
        schema: 'application_form',
        table,
      })),
    [tables],
  );

  usePostgresChangesRealtime({
    enabled: enabled && tables.length > 0,
    channelName: `forms-settings-live:${tables.join('+')}`,
    portalKind: 'forms',
    syncSecondaryAuth: true,
    debounceMs: 500,
    onChange,
    listens,
  });
}
